import BackRouter from "@/components/customs/BackRouter";
import Logo from "@/components/customs/Logo";
import { ArrowLeft } from "iconsax-react";
import Image from "next/image";

import RegisterTabs from "./RegisterTabs";

import { SupportedLanguage } from "@/lib/shared";
import lang from "./lang.json";

type RegisterProps = {
  locale: SupportedLanguage;
  tab: string;
};

export default function Register({
  locale,
  tab,
}: RegisterProps) {
  return (
    <div className="flex relative min-h-screen">
      <div className="hidden md:flex w-1/2 bg-primary-darken items-center justify-center p-10 h-screen fixed top-0 left-0 rtl:left-auto rtl:right-0">
        <div className="max-w-lg text-center">
          <div className="flex flex-col items-center">
            <div className="relative w-full aspect-[4/3] max-h-[50vh]">
              <Image
                src="/images/illustration-users-register.png"
                alt=""
                fill
                className="object-contain"
                sizes="(min-width: 768px) 50vw, 100vw"
              />
            </div>
            <div className="mb-10"></div>
            <h2 className="text-3xl font-bold text-white mb-4">
              Sell Your Car Fast
            </h2>
            <p className="text-white text-opacity-90">
              Upload photos, set a price, and find buyers easily.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full md:w-1/2 ml-auto rtl:mr-auto rtl:ml-0">
        <div className="flex flex-col gap-y-8 max-w-md mx-auto w-full p-10 min-h-screen">
          <div className="flex gap-x-8 items-center">
            <BackRouter>
              <span className="text-gray-950 cursor-pointer">
                <ArrowLeft
                  size="32"
                  variant="Outline"
                  className="fill-current"
                />
              </span>
            </BackRouter>
            <Logo />
          </div>

          <span className="flex flex-col gap-y-2">
            <h1 className="text-3xl font-bold">
              {lang["create-account"][locale]}
            </h1>
            <p className="text-gray-600">
              {lang["create-account-description"][locale]}
            </p>
          </span>

          <RegisterTabs initialTab={tab} locale={locale} />
        </div>
      </div>
    </div>
  );
}
